import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

function OtherStock() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const { isAuthenticated, companyId, companyName, permissions, token, logout } = useAuth();
    const [totalopbal, setTotalopbal] = useState(0);
    const [totalp, setTotalp] = useState(0);
    const [totalprtn, setTotalprtn] = useState(0);
    const [totals, setTotals] = useState(0);
    const [totalsrtn, setTotalsrtn] = useState(0);
    const [totalstin, setTotalsint] = useState(0);
    const [totalstout, setTotalstout] = useState(0);
    const [totalrpl, setTotalrpl] = useState(0);
    const [totalcls, setTotalcls] = useState(0);
    const [totalstkval, setTotalstkval] = useState(0);
    const [totalsalval, setTotalsalval] = useState(0);
    const [isFocused, setIsFocused] = useState(false);

    const [branchOptions, setBranchOptions] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [branchId, setBranch] = useState(0);
    const [branchName, setBranchName] = useState(0);
    const [selectedBranches, setSelectedBranches] = useState([]); // Use an array for multiple selections

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        fetchCustomerData();
        fetchBranchData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    // const handleBranchSelect = (selectedOption) => {
    //     setSelectedBranch(selectedOption);
    //     const branchId = selectedOption ? selectedOption.value : '';
    //     setBranch(branchId);

    //     const branchName = selectedOption ? selectedOption.label : '';
    //     setBranchName(branchName);

    //     setDataItem([])
    // };

    const handleBranchSelect = (selectedOptions) => {
        setSelectedBranches(selectedOptions);
        const branchIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
        // You can now use branchIds to filter or send to the API
        setDataItem([]); // Clear the data when branches are changed
    };

    const fetchBranchData = () => {
        fetchData('ReportApi', `/Branch/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const options = data.map((customer) => ({
                    label: customer.Name,
                    value: customer.Id,
                }));
                setBranchOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching branch data:', error);
            });
    };

    useEffect(() => {
        // Calculate total 
        let totalopbal = 0;
        let totalp = 0;
        let totalprtn = 0;
        let totals = 0;
        let totalsrtn = 0;
        let totalstin = 0;
        let totalstout = 0;
        let totalrpl = 0;
        let totalcls = 0;
        let totalstkval = 0;
        let totalsalval = 0;


        dataItem.forEach(item => {
            totalopbal += item.OpeningQty;
            totalp += item.PurchaseQty;
            totalprtn += item.PurchaseReturnQty;
            totals += item.SaleQty;
            totalsrtn += item.SaleReturnQty;
            totalstin += item.StockInQty;
            totalstout += item.StockOutQty;
            totalrpl += item.ReplaceQty;
            totalcls += item.ClosingQty;
            totalstkval += item.StockValue;
            totalsalval += item.SaleValue;
        });
        setTotalopbal(totalopbal);
        setTotalp(totalp);
        setTotalprtn(totalprtn);
        setTotals(totals);
        setTotalsrtn(totalsrtn);
        setTotalsint(totalstin);
        setTotalstout(totalstout);
        setTotalrpl(totalrpl);
        setTotalcls(totalcls);
        setTotalstkval(totalstkval);
        setTotalsalval(totalsalval);
    }, [dataItem]);

    const fetchCustomerData = () => {

    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');
    const [loading, setLoading] = useState(false);

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setDataItem([]);

            let branchIds;
            const StockDate = '2025-04-01';
            if (selectedBranches.length === 0) {
                branchIds = branchOptions.map(branch => branch.value);
            } else {
                branchIds = selectedBranches.map(branch => branch.value);
            }

            try {
                setLoading(true);
                const branchIdsString = branchIds.join(',');
                const response = await fetchData('OtherReportApi', `/Stock/${companyId}/${branchIdsString}/${StockDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Stock Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const handleExportExcelS = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Consolidated Stock');

        // ✅ Freeze top 2 rows (title + header)
        worksheet.views = [
            { state: 'frozen', xSplit: 0, ySplit: 2 }
        ];

        const allDataSheet = [];

        const headerRowValues = [
            'Branch', 'Code', 'Item', 'Opening', 'Purchase', 'Purchase Return', 'Sale', 'Sale Return',
            'Stock In', 'Stock Out', 'Replacement', 'Closing', 'Purchase Rate', 'MRP',
            'Stock Value', 'Sale Value', 'GST%', 'HSN Code', 'Disc%', 'Category', 'Group'
        ];

        const rightAlignColumns = [
            'Purchase', 'Purchase Return', 'Sale', 'Sale Return', 'Stock In', 'Stock Out',
            'Replacement', 'Closing', 'Purchase Rate', 'MRP', 'Stock Value', 'Sale Value',
            'GST%', 'Disc%'
        ];

        // Title caption
        const headerCaption = `${companyName} - Consolidated Stock : ${formatDate(fromDate)} To: ${formatDate(toDate)}`;
        worksheet.mergeCells('A1:L1');
        const headerCaptionCell = worksheet.getCell('A1');
        headerCaptionCell.value = headerCaption;
        headerCaptionCell.font = { bold: true, size: 14 };
        headerCaptionCell.alignment = { vertical: 'middle', horizontal: 'left' };

        // Header row
        const headerRow = worksheet.addRow(headerRowValues);
        const thinBorder = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        };

        headerRow.eachCell((cell) => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFB6D7A8' } };
            cell.font = { bold: true };
            cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
            cell.border = thinBorder;
        });

        // Totals
        let totalopbal = 0;
        let totalp = 0;
        let totalprtn = 0;
        let totals = 0;
        let totalsrtn = 0;
        let totalstin = 0;
        let totalstout = 0;
        let totalrpl = 0;
        let totalcls = 0;
        let totalstkval = 0;
        let totalsalval = 0;

        filteredDataItem.forEach((rowData) => {
            const rowValues = [
                rowData.branchName,
                parseFloat(rowData.Code),
                rowData.Name,
                rowData.OpeningQty,
                rowData.PurchaseQty,
                rowData.PurchaseReturnQty,
                rowData.SaleQty,
                rowData.SaleReturnQty,
                rowData.StockInQty,
                rowData.StockOutQty,
                rowData.ReplaceQty,
                rowData.ClosingQty,
                parseFloat(rowData.PurchaseRate.toFixed(2)),
                parseFloat(rowData.MRP.toFixed(2)),
                parseFloat(rowData.StockValue.toFixed(2)),
                parseFloat(rowData.SaleValue.toFixed(2)),
                rowData.GSTRate,
                rowData.HSNCode,
                rowData.DiscountPercentage,
                rowData.StyleName,
                rowData.BrandName
            ];

            allDataSheet.push(rowValues); // Optional: if you use later

            // Update totals
            totalopbal += rowData.OpeningQty;
            totalp += rowData.PurchaseQty;
            totalprtn += rowData.PurchaseReturnQty;
            totals += rowData.SaleQty;
            totalsrtn += rowData.SaleReturnQty;
            totalstin += rowData.StockInQty;
            totalstout += rowData.StockOutQty;
            totalrpl += rowData.ReplaceQty;
            totalcls += rowData.ClosingQty;
            totalstkval += parseFloat(rowData.StockValue.toFixed(2));
            totalsalval += parseFloat(rowData.SaleValue.toFixed(2));

            const row = worksheet.addRow(rowValues);
            row.eachCell((cell, colNumber) => {
                const headerName = headerRowValues[colNumber - 1];
                if (rightAlignColumns.includes(headerName)) {
                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                    cell.numFmt = '#,##0.00';
                } else {
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                }
                cell.border = thinBorder;
            });
        });

        // Add total row
        const totalRowValues = [
            '', '', 'Total', totalopbal, totalp, totalprtn, totals, totalsrtn,
            totalstin, totalstout, totalrpl, totalcls, '', '', totalstkval,
            totalsalval, '', '', '', '', ''
        ];

        const totalRow = worksheet.addRow(totalRowValues);
        totalRow.font = { bold: true };
        totalRow.eachCell((cell, colNumber) => {
            const headerName = headerRowValues[colNumber - 1];
            if (rightAlignColumns.includes(headerName)) {
                cell.alignment = { vertical: 'middle', horizontal: 'right' };
                cell.numFmt = '#,##0.00';
            } else {
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
            }
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE2EFDA' } };
            cell.border = thinBorder;
        });

        // Adjust column widths
        worksheet.columns = headerRowValues.map(() => ({ width: 15 }));

        // Export
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), 'Consolidated Stock.xlsx');
    };

    const branchOptionsWithBlank = [{ label: '--Select--', value: 0 }, ...branchOptions];
    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>
                        Consolidated STOCK
                    </h6>
                </div>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    {loading && (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999
                        }}>
                            <div>
                                <CircularProgress style={{ color: 'white' }} />
                                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                            </div>
                        </div>
                    )}

                    <div style={{ marginBottom: '10px', marginLeft: '20px', display: 'flex', alignItems: 'center' }}>
                        <input
                            className="shadow text-gray-700 leading-tight"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            style={{
                                width: isFocused ? '270px' : '200px',
                                height: '30px',
                                border: '1px solid #ccc',
                                borderRadius: '15px',
                                padding: '0 20px',
                                transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                                outline: 'none',
                                borderColor: isFocused ? 'darkcyan' : '#ccc',
                                boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            }}
                        />
                    </div>

                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px', marginTop: '10px' }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <IconButton onClick={fetchTableData}>
                            {/* <RefreshIcon style={{ color: 'brown' }} /> */}
                        </IconButton>
                        <span style={{ color: 'brown', fontWeight: 'bolder', fontSize: '12px' }}>Refresh</span>
                    </Button>
                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px', marginTop: '10px' }}
                        onClick={handleExportExcelS}
                        className="linkcolor"
                    >
                        <IconButton onClick={handleExportExcelS}>
                            {/* <FeedIcon style={{ color: 'darkgreen' }} /> */}
                        </IconButton>
                        <span style={{ color: 'darkgreen', fontWeight: 'bolder', fontSize: '12px' }}>Excel</span>
                    </Button>

                    <div className="watermark">
                        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                    </div>

                </div>

                {/* <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '10px' }}>
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ fontSize: '12.5px', marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div> */}
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '10px' }}>
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ fontSize: '12.5px', marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>

                <div style={{ width: '100%', maxWidth: '30%', marginLeft: '10px', paddingRight: '5', marginRight: '10px', marginBottom: '2', flexBasis: 'auto' }}>

                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '10px' }}>
                        Branch
                        <span style={{ color: 'red' }}>*</span>
                    </label>

                    <Select
                        options={branchOptionsWithBlank}
                        value={selectedBranches}
                        onChange={handleBranchSelect}
                        placeholder="Select a Branch"
                        isMulti
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: '30px',
                                fontSize: '13px',
                            }),
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 1301,
                                fontSize: '13px',
                            }),
                            indicatorsContainer: (base) => ({
                                ...base,
                                height: '30px',
                            }),
                        }}
                    />
                </div>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '7px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#08396B', Width: '2500px' }}>
                            <TableRow sx={{ whiteSpace: 'nowrap' }}>
                                <TableCell sx={{ backgroundColor: '#7b1107ff', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Store</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Code</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Item</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Opening</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Purchase</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Purchase Return</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Sale</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Sale Return</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Stock In</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Stock Out</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Replacement</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Closing</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Purchase Rate</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>MRP</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Stock Value</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Sale Value </TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>GST%</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>HSN Code</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Disc%</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Style</TableCell>
                                <TableCell sx={{ backgroundColor: '#27445D', borderBottom: '1px solid #F5F5F5', borderRight: '1px solid grey', fontWeight: 'bolder', fontSize: '10px', padding: '3px', color: 'whitesmoke', textTransform: 'uppercase' }}>Brand</TableCell>
                            </TableRow>
                        </TableHead>


                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {filteredDataItem.map((data, index) => (
                                <TableRow
                                    key={data.id}
                                    className={'highlighted-row'}
                                    sx={{
                                        padding: '7px',
                                        backgroundColor: 'transparent',
                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', background: '#FDAB9E', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '10.5px' }}>{data.branchName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px' }}>{data.Code}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px' }}>{data.Name}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.OpeningQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.PurchaseQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.PurchaseReturnQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.SaleQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.SaleReturnQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.StockInQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.StockOutQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.ReplaceQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.ClosingQty}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.PurchaseRate.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.MRP.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.StockValue.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.SaleValue.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px', textAlign: 'right' }}>{data.GSTRate}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px' }}>{data.HSNCode}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px' }}>{data.DiscountPercentage}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px' }}>{data.StyleName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '10.5px' }}>{data.BrandName}</TableCell>
                                </TableRow>
                            ))}

                            <TableRow
                                className={'highlighted-row'}
                                sx={{
                                    padding: '7px',
                                    height: '30px',
                                    background: 'linear-gradient(to right, #063e68ff, #063e68ff)',
                                }}
                            >
                                <TableCell colSpan={3} />
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalopbal}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalp}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalprtn}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totals}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalsrtn}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalstin}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalstout}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalrpl}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalcls}</TableCell>
                                <TableCell colSpan={2} />
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalstkval.toFixed(2)}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{totalsalval.toFixed(2)}</TableCell>
                                <TableCell colSpan={10} />
                            </TableRow>

                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

        </div>
    );
}

export default OtherStock;
